import React, { useEffect, useState } from "react";
import GameCard from "./GameCard";
import api from "../utils/api";

const NewReleases = () => {
  const [games, setGames] = useState([]);

  useEffect(() => {
    api.get('/newreleases')
      .then((response) => {
        // Process and sort the games
        const processedGames = response.data
          .map((game) => ({
            id: game.id,
            title: game.name,
            releaseDateUnix: game.first_release_date,
            releaseDate: new Date(game.first_release_date * 1000).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              timeZone: 'UTC'
            }),
            cover: game.coverUrl || "/StockGameCover.jpg",
            summary: game.storyline || "No synopsis available.",
            rating: game.rating ? game.rating.toFixed(1) : "N/A",
            ratingCount: game.rating_count || 0,
            trailerUrl: game.trailerUrl
              ? game.trailerUrl.replace("watch?v=", "embed/")
              : null,
          }))
          .sort((a, b) => {
            // First, sort by rating (games with ratings first)
            if (a.rating === "N/A" && b.rating !== "N/A") return 1;
            if (a.rating !== "N/A" && b.rating === "N/A") return -1;
            
            // If both have ratings, sort by rating value
            if (a.rating !== "N/A" && b.rating !== "N/A") {
              const ratingDiff = parseFloat(b.rating) - parseFloat(a.rating);
              if (ratingDiff !== 0) return ratingDiff;
              
              // If ratings are equal, sort by number of ratings
              return (b.ratingCount || 0) - (a.ratingCount || 0);
            }
            
            // If neither has ratings, sort by release date
            return b.releaseDateUnix - a.releaseDateUnix;
          })
          .slice(0, 8); // Take the first 8 games after sorting

        setGames(processedGames);
      })
      .catch((error) => {
        console.error("Failed to load games:", error);
      });
  }, []);

  return (
    <section className="bg-gradient-to-br from-[#0f172a] to-[#1e293b] text-white py-14 px-6">
      <h2 className="text-4xl font-extrabold text-center text-blue-400 mb-12">
        New Releases
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 justify-items-center max-w-7xl mx-auto">
        {games.map((game, index) => (
          <GameCard 
            key={index} 
            game={game} 
            variant="dark" 
            showRating={true}
          />
        ))}
      </div>
    </section>
  );
};

export default NewReleases;
